import AddIcon from '@mui/icons-material/Add';
import AutoAwesomeMosaicOutlinedIcon from '@mui/icons-material/AutoAwesomeMosaicOutlined';
import EventIcon from '@mui/icons-material/Event';
import MoneyRoundedIcon from '@mui/icons-material/MoneyRounded';
import { Grid, Box, IconButton } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  ITransacationDetails,
  getClientInvoiceInfo,
  ourEntityBankList,
  saveTranscationDetails,
  getAllClientCurrencies,
  getTranscationDetailsByInvoiceId,
  updateTransactionRecordById,
  getAllActiveCurrenciesByWorkspaceId,
  IClientCurrencySettings,
  saveActivityLog,
  LogEntityType,
  LogAction,
  LogContextType,
} from 'wisestep-api';
import {
  ActiveJob,
  WsTypography,
  getFormatDate,
  WsButton,
  WsChip,
  WsChipVariants,
  WsIconProfile,
  WsColors,
  WsIconViewJD,
  WsIconEdit,
} from 'wisestep-base';

import {
  getAvEditAddDesUiName,
  activityLogDTOHelper,
} from '../../../features/activityLog/ActivityHelper';
import { useInvoicingAuthz, InvoicingAction } from '../../../hooks/useInvoicingAuthz';
import { failed, success, warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import {
  IDrawerDocument,
  IInvoiceDataList,
  IBankAccountObject,
  IInvoiceDataResponse,
  IReceiptTypeList,
  transcationDetailDefaultPayload,
  IDefaultValue,
} from '../helper/InvocieSettingsHelper';

import InvoiceDetailsCard, { InvoiceDetailsCardAttribute, properties } from './InvoiceDetailsCard';
import InvoiceDrawerLayout from './InvoiceDrawerLayout';

const currencyMap = new Map<string, string>();

const TranscationDetails = ({ invoiceId, invoice }: IDrawerDocument) => {
  const [transactionDetailsList, setTransactionDetailsList] = useState<ITransacationDetails[]>([]);
  const [flag, setFlag] = useState<boolean>(false);
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [openTarnscationDialog, setOpenTarnscationDialog] = useState<boolean>(false);
  const [bankInfo, setBankInfo] = useState<IBankAccountObject[]>([]);
  const [clientInvoiceInfo, setClientInvoiceInfo] = useState<IInvoiceDataResponse[]>([]);
  const [ourBankEntityId, setOurBankEntityId] = useState<string>();
  const [selectedValue, setSelectedValue] = useState<ITransacationDetails>();
  const [editTranscationIndexValue, setEditTranscationIndexValue] = useState<number>(0);
  const [openTarnscationEditDialog, setOpenTarnscationEditDialog] = useState<boolean>(false);
  const [currencyList, setCurrencyList] = useState<IClientCurrencySettings[]>([]);

  const isAuthorizedAddTranscation = useInvoicingAuthz(
    InvoicingAction.ADD_INVOICE_DETAILS_ADD_TRANSACTION
  );

  const isAuthorizedEditTranscation = useInvoicingAuthz(
    InvoicingAction.INVOICE_DETAILS_EDIT_TRANSACTION
  );

  useEffect(() => {
    const getCurrencyData = async () => {
      const response = await getAllActiveCurrenciesByWorkspaceId();
      setCurrencyList(response.data);
    };

    getCurrencyData();
    const fetchDataTranscationDetails = async () => {
      const res = await getTranscationDetailsByInvoiceId(invoiceId);
      setTransactionDetailsList(res.data);
      const response = await getAllClientCurrencies();
      response.data.forEach((value) => {
        currencyMap.set(value.id, value.symbol);
      });
    };

    fetchDataTranscationDetails();

    const fetchAddTranscationDetails = async () => {
      const responseInvoice = await getClientInvoiceInfo(invoiceId);
      setClientInvoiceInfo([responseInvoice.data as unknown as IInvoiceDataResponse]);
      setOurBankEntityId(responseInvoice.data.ourEntityId);
      const responseBankEnity = await ourEntityBankList(
        responseInvoice.data.ourEntityId ?? '',
        0,
        100
      );
      setBankInfo(responseBankEnity.data.data);
    };
    fetchAddTranscationDetails();
  }, [flag, setNotification, invoiceId]);

  const defaultTranscationalRowDataValue: IInvoiceDataList[] =
    clientInvoiceInfo?.map((i) => ({
      invoice_code: i.invoiceCode,
      amount: i.total,
      adjustment: i.paid,
      amountOs: i.remainingAmount,
      commentsInfo: '',
      invoiceCurrency: i.currencySymbol,
    })) ?? [];

  const categoriesCurrencyTypeList: IReceiptTypeList[] =
    currencyList?.map((currencyList) => ({
      label: currencyList.symbol,
      value: currencyList.id,
    })) ?? [];

  const categoriesBankList: IReceiptTypeList[] =
    bankInfo?.map((bankInfo) => ({
      label: bankInfo.bankName,
      value: bankInfo.id,
    })) ?? [];

  const onAddTransacation = async (data, arrayDirity) => {
    const avPayload = { ...activityLogDTOHelper };
    const payload = { ...transcationDetailDefaultPayload };
    payload.amount = data.transcationAmount;
    payload.paymentReferenceId = data.paymentReference;
    payload.transactionComment = data.transactionComment;
    payload.paymentDate = data.transcationDate;
    payload.currencyId = data.currencyType;
    payload.clientId = ourBankEntityId;
    payload.ourEntityBankId = data.bankName;
    payload.paymentTypeId = data.paymentType;
    payload.clientInvoiceId = invoiceId;

    try {
      const res = await saveTranscationDetails(payload);
      avPayload.action = LogAction.Add;
      avPayload.description = `ADDED new Transcation in Transcation Details under Invoice`;
      avPayload.parentEntitiyType = LogContextType.Invoice;
      avPayload.entityType = LogEntityType.Transcation;
      avPayload.entityId = res.data.id;
      avPayload.parentEntitiyId = invoiceId;
      avPayload.field = `Transcation Details`;
      avPayload.entityName = data.transactionComment;
      avPayload.contextData = { invoiceId: invoiceId };
      arrayDirity[0].length > 0 ? await saveActivityLog(avPayload) : '';
      setFlag(!flag);
      setNotification(success(`Receipt has been added successfully !!`));
      setOpenTarnscationDialog(false);
    } catch (error: any) {
      if (error.response.status === 400)
        setNotification(warning(`Oops , Receipts already exists!!`));
      else setNotification(failed('Something went wrong !!'));
    }
  };

  const editTranscationValue = (index: number) => {
    setEditTranscationIndexValue(index);
    const tempPayload = transactionDetailsList[index];
    setSelectedValue(tempPayload);
    setOpenTarnscationEditDialog(true);
  };

  const getDefaultValue: IDefaultValue = {
    bankName: selectedValue?.ourEntityBankId,
    transcationDate: String(selectedValue?.paymentDate),
    paymentReference: selectedValue?.paymentReferenceId,
    transcationAmount: selectedValue?.amount,
    transactionComment: selectedValue?.transactionComment,
    currencyType: selectedValue?.currencyId,
  };

  const onUpdateTransaction = async (data, arrayDirity) => {
    const avPayload = { ...activityLogDTOHelper };
    const payload = transactionDetailsList[editTranscationIndexValue];
    const avEmptyEntityfields = Object.keys(
      Object.entries(payload).reduce((acc, [k, v]) => {
        if (v === '' || v === null) acc[k] = v;
        return acc;
      }, {})
    );
    avPayload.description = `${getAvEditAddDesUiName(
      'Invoice',
      avEmptyEntityfields,
      arrayDirity
    )} under Invoice`;
    payload.amount = data.transcationAmount;
    payload.paymentReferenceId = data.paymentReference;
    payload.transactionComment = data.transactionComment;
    payload.paymentDate = data.transcationDate;
    payload.currencyId = data.currencyType;
    payload.clientId = ourBankEntityId;
    payload.ourEntityBankId = data.bankName;
    payload.paymentTypeId = data.paymentType;
    payload.clientInvoiceId = invoiceId;
    try {
      if (payload.id) {
        await updateTransactionRecordById(payload.id, payload);
        avPayload.action = LogAction.Edit;
        avPayload.parentEntitiyType = LogContextType.Invoice;
        avPayload.entityType = LogEntityType.Transcation;
        avPayload.parentEntitiyId = payload.clientInvoiceId;
        avPayload.entityId = payload.id;
        avPayload.field = `Transcation Details`;
        avPayload.entityName = data.transactionComment;
        avPayload.contextData = { invoiceId: invoiceId };

        arrayDirity[0].length > 0 ? await saveActivityLog(avPayload) : '';
        setNotification(success(`Receipt has been modified successfully !!`));
        setOpenTarnscationEditDialog(false);
        setFlag(!flag);
      } else setNotification(warning('Receipt not found !!'));
    } catch {
      setNotification(failed('Something went wrong , Please try again !!'));
    }
  };

  return (
    <>
      {isAuthorizedAddTranscation && invoice?.invoiceStage !== 'VOID' && (
        <Grid item xs={12} pt={2} pb={2} container justifyContent={'flex-end'}>
          <WsButton
            startIcon={<AddIcon />}
            variant="outlined"
            onClick={() => setOpenTarnscationDialog(true)}
          >
            Add Transaction
          </WsButton>
        </Grid>
      )}
      {transactionDetailsList.map((data, index) => (
        <Box key={index} pt={2}>
          <InvoiceDetailsCard
            key={index}
            icon={<ActiveJob />}
            title={String(data.paymentReferenceId)}
            right={
              <>
                {isAuthorizedEditTranscation && (
                  <IconButton onClick={() => editTranscationValue(index)}>
                    <WsIconEdit />
                  </IconButton>
                )}
              </>
            }
          >
            <InvoiceDetailsCardAttribute columns={4}>
              <EventIcon />
              <WsTypography {...properties}>{getFormatDate(String(data.paymentDate))}</WsTypography>
            </InvoiceDetailsCardAttribute>
            <InvoiceDetailsCardAttribute columns={3}>
              <WsIconProfile color={WsColors.GreyBlack} />
              <WsTypography {...properties}>{data.createdByName}</WsTypography>
            </InvoiceDetailsCardAttribute>
            <InvoiceDetailsCardAttribute columns={3}>
              <WsIconViewJD />
              <WsChip value="Receipt" variant={WsChipVariants.SUCCESS} isPointer={true} />
            </InvoiceDetailsCardAttribute>
            <InvoiceDetailsCardAttribute columns={4}>
              <MoneyRoundedIcon />
              <WsTypography {...properties}>
                {currencyMap.get(String(data.currencyId))}
                {''} {data.amount}
              </WsTypography>
            </InvoiceDetailsCardAttribute>
            <InvoiceDetailsCardAttribute columns={4}>
              <AutoAwesomeMosaicOutlinedIcon />
              <WsTypography {...properties}>{data.transactionComment}</WsTypography>
            </InvoiceDetailsCardAttribute>
          </InvoiceDetailsCard>
        </Box>
      ))}
      {openTarnscationDialog && (
        <InvoiceDrawerLayout
          openDialog={openTarnscationDialog}
          closeDialog={() => setOpenTarnscationDialog(false)}
          onInput={(data, arrayDirity) => onAddTransacation(data, arrayDirity)}
          name="Add Receipts"
          isView={false}
          isTransactionDrawer={true}
          bankDetailsList={categoriesBankList as []}
          currencyTypeList={categoriesCurrencyTypeList as []}
          defaultTranscationalRowData={defaultTranscationalRowDataValue}
        />
      )}
      {openTarnscationEditDialog && (
        <InvoiceDrawerLayout
          openDialog={openTarnscationEditDialog}
          closeDialog={() => setOpenTarnscationEditDialog(false)}
          onInput={(data, arrayDirity) => onUpdateTransaction(data, arrayDirity)}
          name="Edit Receipts"
          isView={false}
          isTransactionDrawer={true}
          bankDetailsList={categoriesBankList as []}
          defaultValue={getDefaultValue}
          currencyTypeList={categoriesCurrencyTypeList as []}
          defaultTranscationalRowData={defaultTranscationalRowDataValue}
        />
      )}
    </>
  );
};

export default TranscationDetails;
